import { css } from "@emotion/react";

export const selectWithSearchCss = css`
  min-width: 250px;

  & > .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"] {
    padding: 0 0 2px 8px;
    border-radius: 25px;

    & > ::placeholder {
      opacity: 1;
      color: rgba(0, 0, 0, 0.6);
    }
  }

  & > div > fieldset {
    border: 1px solid #ced4da;
    min-height: 40px;
  }
`;

export const selectWithSearchFWCss = css`
  & > .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"] {
    padding: 0 0 2px 8px;
    border-radius: 25px;

    & > ::placeholder {
      opacity: 1;
      color: rgba(0, 0, 0, 0.6);
    }
  }

  & > div > fieldset {
    border: 1px solid #ced4da;
    min-height: 40px;
  }
`;
